import { render, staticRenderFns } from "./UserGroupTable.vue?vue&type=template&id=c0df3f34&"
import script from "./UserGroupTable.vue?vue&type=script&lang=js&"
export * from "./UserGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports